/**
 * Toggle — Switch visual dark theme com disabled e tamanhos
 */
import { T } from '../../styles/tokens';

type ToggleSize = 'sm' | 'md';

interface ToggleProps {
  label: string;
  value: boolean;
  onChange: (v: boolean) => void;
  description?: string;
  disabled?: boolean;
  size?: ToggleSize;
}

const dims: Record<ToggleSize, { w: number; h: number; knob: number; offset: number }> = {
  sm: { w: 38, h: 22, knob: 16, offset: 3 },
  md: { w: 52, h: 28, knob: 22, offset: 3 },
};

export function Toggle({ label, value, onChange, description, disabled, size = 'md' }: ToggleProps) {
  const d = dims[size];

  return (
    <div
      style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        gap: T.space3, cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
      onClick={() => !disabled && onChange(!value)}
    >
      <div>
        <div style={{ fontSize: T.textMd, fontWeight: T.weightMedium, color: T.text }}>{label}</div>
        {description && <div style={{ fontSize: T.textSm, color: T.textMuted, marginTop: 2 }}>{description}</div>}
      </div>
      <div style={{
        width: d.w, height: d.h, borderRadius: d.h / 2,
        background: value ? T.success : T.borderHover,
        transition: `background ${T.transitionNormal}`,
        position: 'relative',
        flexShrink: 0,
      }}>
        <div style={{
          width: d.knob, height: d.knob,
          borderRadius: '50%',
          background: '#fff',
          position: 'absolute',
          top: d.offset,
          left: value ? d.w - d.knob - d.offset : d.offset,
          transition: `left ${T.transitionNormal}`,
        }} />
      </div>
    </div>
  );
}
